// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"415e91ad","274":"4ec68315","315":"5446497c","383":"32b4cbfc","496":"749fd0b2","596":"974f69a2"}[chunkId] + ".chunk.js";
};